// -----------------------------------------------------------
// FloraIQ - StageStatusBadge
// -----------------------------------------------------------

import type { StageStatus } from "@/mocks/operational";

interface StageStatusBadgeProps {
  status: StageStatus;
  className?: string;
}

const statusConfig: Record<StageStatus, { label: string; bg: string; text: string; icon: string }> = {
  nao_iniciada: { label: "Não iniciada", bg: "bg-background-100", text: "text-foreground-500", icon: "ri-circle-line" },
  planejada: { label: "Planejada", bg: "bg-blue-100", text: "text-blue-700", icon: "ri-calendar-check-line" },
  em_andamento: { label: "Em andamento", bg: "bg-orange-100", text: "text-orange-700", icon: "ri-play-circle-line" },
  em_revisao: { label: "Em revisão", bg: "bg-yellow-100", text: "text-yellow-700", icon: "ri-search-eye-line" },
  concluida: { label: "Concluída", bg: "bg-green-100", text: "text-green-700", icon: "ri-check-double-line" },
  bloqueada: { label: "Bloqueada", bg: "bg-red-100", text: "text-red-700", icon: "ri-forbid-line" },
  reaberta: { label: "Reaberta", bg: "bg-purple-100", text: "text-purple-700", icon: "ri-refresh-line" },
};

export default function StageStatusBadge({ status, className = "" }: StageStatusBadgeProps) {
  const config = statusConfig[status];

  return (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${config.bg} ${config.text} ${className}`}>
      <i className={`${config.icon} text-xs`}></i>
      {config.label}
    </span>
  );
}

export function getStageStatusLabel(status: StageStatus): string {
  return statusConfig[status]?.label || status;
}